import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import OverallMetric from "../components/OverallMetric";
import InfoTooltip from "../components/InfoTooltip";
import DemographicsChart from "../components/DemographicsChart";
import Geography from "../components/Geography";
import BrandSources from "../components/BrandSources";
import BestSocialMediaPostBubbles from "../components/BestSocialMediaPostBubbles";
import PerformingSocialMediaPosts from "../components/PerformingSocialMediaPosts";
import VisibilityGraph from "../components/VisibilityGraph";
import EngagementGraph from "../components/EngagementGraph";
import PerformingSocialMediaMentions from "../components/PerformingSocialMediaMentions";
import PerformingSocialMediaTagged from "../components/PerformingSocialMediaTagged";
import LineGraph from "../components/LineGraph";
import BarGraph from "../components/BarGraph";
import LogoPlacementTable from "../components/LogoPlacementTable";
import MarketAnalysisTable from "../components/MarketAnalysisTable";
import SponsorValueBreakdown from "../components/SponsorValueBreakdown";
import { useSponsorStationDividedValue } from "../query/hooks";
import useSponsorTvDiveded from "../query/hooks/useSponsorTvDiveded";
import { connect } from "react-redux";

const BETSSON_TENANT_ID = 179;

const DashboardAssiciation = ({ selectedCurrency, tenant }) => {
  const { t } = useTranslation();
  const isBetsson = tenant?.id === BETSSON_TENANT_ID || tenant?.name === "Betsson";

  return (
    <>
      <div className="container-fluid pt-4">
        <Row>
          <Col xl={3} md={6} className="mb-4">
            <OverallMetric
              metric="followers"
              tooltip={t("association_followers_tooltip")}
            />
          </Col>
          <Col xl={3} md={6} className="mb-4">
            <OverallMetric
              metric="engagement"
              followCalender
              tooltip={t("association_engagement_tooltip")}
            />
          </Col>
          <Col xl={3} md={6} className="mb-4">
            <OverallMetric
              followCalender
              metric="press-mentions"
              tooltip={t("association_pressMentions_tooltip")}
              noTrend
            />
          </Col>
          <Col xl={3} md={6} className="mb-4">
            <OverallMetric
              followCalender
              metric="sentiment"
              tooltip={t("association_sentiment_tooltip")}
              noTrend
              numeralFormat="0%"
              variant="ratio-bar"
            />
          </Col>
        </Row>
        {isBetsson && (
          <Row className="mb-4">
            <Col sm={12}>
              <Card className="mini-stat bg-card text-white">
                <CardBody>
                  <SponsorValueBreakdown />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        <Row>
          <Col sm={12} md={6} className="mb-4">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">{t("Rekkevidde")}</h4>
                <VisibilityGraph />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} md={6} className="mb-4">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">{t("Engasjement")}</h4>
                <EngagementGraph />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={6} className="mb-4">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Alder og kjønn")}
                  <InfoTooltip
                    tooltip={t("association_demographics_tooltip")}
                  />
                </h4>
                <DemographicsChart />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} md={6} className="mb-4">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Geografi")}
                  <InfoTooltip
                    tooltip={t("association_geography_tooltip")}
                  />
                </h4>
                <Geography />
              </CardBody>
            </Card>
          </Col>
        </Row>
        {isBetsson && (
          <>
            <Row className="mb-4">
              <Col sm={12} md={6} className="mb-4 mb-xl-0">
                <Card className="mini-stat bg-card text-white h-100">
                  <CardBody>
                    <h4 className="card-title mb-4">
                      {t("Sponsorverdi per TV-kanal")} ({selectedCurrency.currency})
                    </h4>
                    <LineGraph
                      useGraphQuery={useSponsorStationDividedValue}
                      defaultActiveTab={0}
                      queryParams={[0]}
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col sm={12} md={6} className="mb-4 mb-xl-0">
                <Card className="mini-stat bg-card text-white h-100">
                  <CardBody>
                    <h4 className="card-title mb-4">{t("TV seere")}</h4>
                    <BarGraph
                      useGraphQuery={useSponsorTvDiveded}
                      queryParams={[0]}
                      scrollbar
                      direction="horizontal"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col sm={12} md={6}>
                <Card className="mini-stat bg-card text-white h-100">
                  <CardBody>
                    <h4 className="card-title mb-4">
                      {t('Logo Placement Analysis')}
                    </h4>
                    <LogoPlacementTable sponsorObjectId={0} />
                  </CardBody>
                </Card>
              </Col>
              <Col sm={12} md={6}>
                <Card className="mini-stat bg-card text-white h-100">
                  <CardBody>
                    <h4 className="card-title mb-4">
                      {t('Markets')}
                    </h4>
                    <MarketAnalysisTable sponsorObjectId={0} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col sm={12} className="mb-4">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Presseomtale")}
                  <InfoTooltip
                    tooltip={t("association_pressCoverage_tooltip")}
                  />
                </h4>
                <BrandSources />
              </CardBody>
            </Card>
          </Col>
          {/* TODO <Col sm={12} md={6} className="mb-4">
            <Card className="mini-stat bg-card text-white">
              <CardBody>VERDISKAPNING PER PROSJEKT</CardBody>
            </Card>
          </Col> */}
        </Row>
        {/* TODO <Row>
          <Col xs={12} className="mb-4">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                Sosialtidslinje
              </CardBody>
            </Card>
          </Col>
        </Row> */}
        <Row className="mb-4">
          <Col md={12}>
            <BestSocialMediaPostBubbles />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-4">
            <PerformingSocialMediaPosts type="BESTE" />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-4">
            <PerformingSocialMediaPosts type="SVAKESTE" />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-4">
            <PerformingSocialMediaMentions />
          </Col>
        </Row>

        <Row>
          <Col md={12} className="mb-4">
            <PerformingSocialMediaTagged />
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(DashboardAssiciation);
